import { useQuery } from "@tanstack/react-query";

import { getReferralSummaryService } from "./service";

export const referralSummaryQueryKey = ["v1/partner_referral_summary_admin"];

export function useReferralSummaryQuery() {
  return useQuery({
    queryKey: referralSummaryQueryKey,
    queryFn: getReferralSummaryService,
  });
}
